import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const Intents = Loadable(
  lazy(() =>
    import("./Intents").then(({ Intents }) => ({
      default: Intents,
    })),
  ),
);

export const IntentsRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.GenAI.Intents,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.INTENT]} allowFullAccess>
        <Intents />
      </AuthorizedRoute>
    ),
  },
];
